'use strict';

var _require = require('./handler');

var isArrayOrObject = _require.isArrayOrObject;
var omitFields = _require.omitFields;


var main = function main() {
  var collection = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
  var fieldsToOmit = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];

  var collectionType = isArrayOrObject(collection);

  switch (collectionType) {
    case 'array':
      return collection.map(function (object) {
        return omitFields({ object: object, fieldsToOmit: fieldsToOmit });
      });
    case 'object':
      return omitFields({ object: collection, fieldsToOmit: fieldsToOmit });
    default:
      throw new Error('Invalid collection provided: expected are [] or [{}]');
  }
};

module.exports = main;


//////////////////
// WEBPACK FOOTER
// ./~/fp-omit/src/index.js
// module id = 1270
// module chunks = 2